<template>
  <div>
    <page-table ref="pageTable" :init-fetch="true" :loading="tableLoading" :columns="tableColumns"
                :page-total="pageTotal" :table-data="tableData" :show-create-btn="false"
                @fetchData="fetchData">
      <template slot="searchForm">
        <FormItem class="margin-bottom-0">
          <Input v-model="params.nickname" placeholder="反馈用户" style="width: 300px;"></Input>
        </FormItem>
      </template>
      <template slot-scope="{row, index}" slot="type">
        <span v-if="row.type === '1'">性能体验：白屏、卡顿、闪退、加载不出来</span>
        <span v-else-if="row.type === '2'">功能异常：功能故障或不可用</span>
        <span v-else-if="row.type === '3'">产品建议：用的不爽，我有建议</span>
        <span v-else>其他建议</span>
      </template>
<!--      <template slot-scope="{ row, index }" slot="action">-->
<!--        <Poptip confirm title="确定要删除吗?" placement="left" @on-ok="btnHandler('delete', row)"-->
<!--                @on-cancel="btnHandler('cancel', row)" transfer>-->
<!--          <Button type="warning" size="small" icon="md-trash"></Button>-->
<!--        </Poptip>-->
<!--      </template>-->
    </page-table>
  </div>
</template>

<script>
import pageTable from '../../components/pageTable/index'
import { delNotice } from '../../api/article'
import tinymce from '../../components/tinymce/index'
import { getFeedbackList } from '../../api/member'

export default {
  name: 'feedback',
  components: { pageTable, tinymce },
  data () {
    return {
      params: {
        nickname: ''
      },
      tableLoading: false,
      tableColumns: [
        { title: '反馈用户', key: 'nickname', width: 230 },
        { title: '反馈类型', key: 'type', slot: 'type' },
        { title: '反馈内容', key: 'content', width: 100 },
        { title: '反馈图片', key: 'images', align: 'right', width: 160 },
        { title: '反馈时间', key: 'create_time', align: 'right', width: 160 }
      ],
      pageTotal: 0,
      tableData: [],
      formData: {
        visible: false,
        title: '',
        fields: [
          { label: '公告标题', key: 'title', type: 'input' },
          { label: '公告详情', key: 'content', type: 'editor' },
          { label: '是否置顶', key: 'is_top', type: 'switch' }
        ],
        data: {}
      }
    }
  },
  methods: {
    fetchData (page) {
      this.tableLoading = true
      const params = { ...this.params, ...page }
      getFeedbackList(params).then(({ data }) => {
        this.tableData = data.data
        this.pageTotal = data.total
      }).finally(() => {
        this.tableLoading = false
      })
    },
    btnHandler (e, row) {
      this[e](row)
    },
    delete (row) {
      delNotice({ id: row.id }).then(({ data }) => {
        this.$Message.success({
          content: '删除成功~'
        })
        this.fetchData()
      })
    }
  }
}
</script>
